import type { VariantProps } from 'class-variance-authority'
import { Loader2 } from 'lucide-react'
import type * as React from 'react'
import { Button, type buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils'

type ButtonProps = React.ComponentProps<'button'> &
	VariantProps<typeof buttonVariants> & {
		asChild?: boolean
	}

interface LoadingButtonProps extends ButtonProps {
	pending?: boolean
	pendingLabel?: string
}

export function LoadingButton({
	pending = false,
	pendingLabel,
	disabled,
	children,
	className,
	...props
}: LoadingButtonProps) {
	return (
		<Button
			{...props}
			disabled={pending || disabled}
			aria-busy={pending || undefined}
			className={cn(className)}
		>
			{pending ? (
				<>
					<Loader2 className="size-4 animate-spin" />
					{pendingLabel ?? children}
				</>
			) : (
				children
			)}
		</Button>
	)
}
